import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataFieldGroupListDataService } from './data-field-group-list-data.service';
import { DataFieldService } from './data-field.service';
import { DataFieldGroupEditModule } from './data-field-group-edit/data-field-group-edit.module';
import { ItemsListModule } from '../components/items-list/items-list.module';
import { UIRouterModule } from '@uirouter/angular';
import { DataFieldStates } from '@fi-app/data-field/data-field-states';
import { DataFieldHelperService } from '@fi-app/data-field/data-field-helper.service';

@NgModule({
    imports: [CommonModule, DataFieldGroupEditModule, ItemsListModule, UIRouterModule.forChild(DataFieldStates)],
    providers: [DataFieldService, DataFieldGroupListDataService, DataFieldHelperService],
})
export class DataFieldModule {}
